import { render, staticRenderFns } from "./border-style.vue?vue&type=template&id=30937c47&"
import script from "./border-style.vue?vue&type=script&lang=js&"
export * from "./border-style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports